import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';

const DEFAULT_SCORE = 0;

@Injectable({
  providedIn: 'root',
})
export class ScoreManager {
  public allSavings$ = new BehaviorSubject<number[]>([]);
  public score$ = new BehaviorSubject<number>(DEFAULT_SCORE);

  setSavings$(savings) {
    this.allSavings$.next(savings);
  }
  private average = (elements: number[]) =>
    elements.reduce((previous, current) => previous + current, 0) /
    elements.length;

  public getScore$() {
    return this.score$.asObservable();
  }

  public setScore(score: number) {
    this.score$.next(score);
  }

  public calculateScore(
    previousUserSavings: number,
    currentUserSavings: number
  ) {
    this.areValuesLoaded()
      ? this._calculateScore(
          previousUserSavings,
          currentUserSavings,
          this.allSavings$.getValue()
        )
      : this._waitAndCalculate(previousUserSavings, currentUserSavings);
  }

  private _calculateScore(
    previousUserSavings: number,
    currentUserSavings: number,
    globalSavings: number[]
  ) {
    const savingsFromPeople = globalSavings.filter(
      (saving) => saving !== undefined
    );
    const index = previousUserSavings
      ? savingsFromPeople.indexOf(previousUserSavings)
      : savingsFromPeople.indexOf(currentUserSavings);
    if (index > -1) savingsFromPeople.splice(index, 1);

    const peopleAveragesavings = this.average(savingsFromPeople);
    console.log(currentUserSavings / peopleAveragesavings);

    this.setScore(currentUserSavings / peopleAveragesavings);
    this.allSavings$.next([...savingsFromPeople, currentUserSavings]);
  }

  private _waitAndCalculate(
    previousUserSavings: number,
    currentUserSavings: number
  ) {
    this.allSavings$.pipe(take(2)).subscribe((globalSavings: number[]) => {
      if (globalSavings.length > 0)
        this._calculateScore(
          previousUserSavings,
          currentUserSavings,
          globalSavings
        );
    });
  }

  private areValuesLoaded(): boolean {
    return this.allSavings$.getValue().length > 0;
  }
}
